// Shared US phone-number normalizer.
//
// Normalizes a raw phone number to canonical E.164 form (+1XXXXXXXXXX for US).
// This is the single source of truth for the "10 digits -> +1 + digits; 11
// digits starting with 1 -> + + digits" rule that was previously duplicated in
// Contacts.js and Messages.js (and implicitly needed by lineContacts.js's
// isNumberSaved). Keep this in sync with any backend/national-number logic.
//
// Edge cases behave as the original inline copies did:
//   - null/undefined/empty -> "+" (harmless; callers guard on truthiness)
//   - 10 digits           -> +1XXXXXXXXXX
//   - 11 digits w/ leading 1 -> +1XXXXXXXXXX
//   - already +XXXXXXXXXX  -> passed through unchanged
//   - anything else       -> "+" + digits
export function formatNumber(raw) {
  raw = raw || "";
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 10) return "+1" + digits;
  if (digits.length === 11 && digits.startsWith("1")) return "+" + digits;
  if (raw.startsWith("+")) return raw;
  return "+" + digits;
}
